import React, { useEffect } from 'react';
import { Toast, ToastProps } from '@im/ui-lib/zenith/Toast';

type Props = {
  alert: boolean;
  setAlert: (enable: boolean) => void;
  severity: ToastProps['intent'];
  text: string;
};

export function AlertPopup(props: Props) {
  const { alert, setAlert, severity, text } = props;

  useEffect(() => {
    const timeOut = setTimeout(() => {
      setAlert(false);
    }, 6000);
    return () => {
      clearTimeout(timeOut);
    };
  });

  const handleClose = () => {
    setAlert(false);
  };

  return (
    <Toast
      header={undefined}
      icon={severity === 'success' ? 'AlertCircle' : 'CheckCircle'}
      intent={severity}
      onCloseButtonClick={handleClose}
      open={alert}
      position="top-center"
      supportingText={text}
    />
  );
}
